import { createApp } from 'vue';
import auth_page from "./AuthPage.vue";


// window.G_AUTH = createApp({
const G_AUTH = createApp({
    name: "G_AUTH",
    id: "G_AUTH",
    components: {
        auth_page
    }
});
//G_AUTH.mount('#go_auth');
export default G_AUTH;
